import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { GlobalMenuGroupsRouteNames, GlobalMenuGroupsRoutePathNames } from '../../../../enums';

const Component = () => import('./ArchivedBrands.vue');

export default {
  path: buildChildURL(GlobalMenuGroupsRoutePathNames.ARCHIVED_BRANDS),
  name: GlobalMenuGroupsRouteNames.ARCHIVED_BRANDS,
  component: Component,
} as RouteRecordRaw;
